var carouselV2 = require("../../templates/components/carousel-v2/carousel-v2");

function initializeCarouselsAndCloudinary($container) {
    $container.find(".Carousel-v2").each(function () {
        new carouselV2(this);
    });

    $container.find("img.cld-responsive").each(function () {
        var $img = $(this);
        var dam = $img.data("dam");
        var name = $img.data("name");
        var transformations = $img.data("transformations");

        if (dam && name && transformations) {
            var src = dam + transformations + "/" + name;
            $img.attr("src", src);
            $img.attr("data-csrc", src);
            $img.addClass("is-initialized is-loaded");
        }
    });

    $.cloudinary.responsive();
}

module.exports = {
    initializeCarouselsAndCloudinary: initializeCarouselsAndCloudinary
};
